export default {
  'All Cycles': 'all_cycles',
  'Good Cycles': 'good_cycles',
  'Bad Cycles': 'bad_cycles',
};
